const ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';

export function generateGameId(random: () => number = Math.random, length = 6): string {
  let id = '';
  for (let i = 0; i < length; i += 1) {
    id += ALPHABET[Math.floor(random() * ALPHABET.length)];
  }
  return id;
}

export function normalizeGameId(raw: string): string {
  return raw.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
}
